<template>
  <div class="thq-section-padding" v-bind:class="rootClassName">
    <div class="home-services-container2 thq-section-max-width">
      <div class="home-services-tabs-menu">
        <div @click="activeTab = 0" class="home-services-tab-horizontal1">
          <div class="home-services-divider-container1">
            <div v-if="activeTab === 0" class="home-services-container3"></div>
          </div>
          <div class="home-services-content1">
            <h2 class="thq-heading-2">
              <slot name="feature1Title">
                <!--Default content for feature1Title-->
                <div class="home-services-fragment3">
                  <span class="home-services-text3">Herbalist Services</span>
                </div>
              </slot>
            </h2>
            <span class="thq-body-small">
              <slot name="feature1Description">
                <!--Default content for feature1Description-->
                <div class="home-services-fragment4">
                  <span class="home-services-text4">
                    Stephanie Davis, a Certified Western and Integrative
                    Herbalist, provides expert herbalist consultations and
                    services to help you achieve your wellness goals.
                  </span>
                </div>
              </slot>
            </span>
          </div>
        </div>
        <div @click="activeTab = 1" class="home-services-tab-horizontal2">
          <div class="home-services-divider-container2">
            <div v-if="activeTab === 1" class="home-services-container4"></div>
          </div>
          <div class="home-services-content2">
            <h2 class="thq-heading-2">
              <slot name="feature2Title">
                <!--Default content for feature2Title-->
                <div class="home-services-fragment2">
                  <span class="home-services-text2">Gardening Services</span>
                </div>
              </slot>
            </h2>
            <span class="thq-body-small">
              <slot name="feature2Description">
                <!--Default content for feature2Description-->
                <div class="home-services-fragment1">
                  <span class="home-services-text1">
                    Stephanie Davis, a Certified Western and Integrative
                    Herbalist, provides expert herbalist consultations and
                    services to help you achieve your wellness goals.
                  </span>
                </div>
              </slot>
            </span>
          </div>
        </div>
      </div>
      <div class="home-services-image-container">
        <img
          :alt="feature1ImgAlt"
          :src="feature1ImgSrc"
          v-if="activeTab === 0"
          class="home-services-image1 thq-img-ratio-16-9"
        />
        <img
          :alt="feature2ImgAlt"
          :src="feature2ImgSrc"
          v-if="activeTab === 1"
          class="home-services-image2 thq-img-ratio-16-9"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeServices',
  props: {
    feature1ImgAlt: {
      type: String,
      default: 'Image of various all natural products',
    },
    feature1ImgSrc: {
      type: String,
      default: '/photo15-small-1400w.jpg',
    },
    feature2ImgAlt: {
      type: String,
      default: 'Image of Stephanie Davis providing herbalist services',
    },
    feature2ImgSrc: {
      type: String,
      default: '/photo11-small-1400w.jpg',
    },
    rootClassName: String,
  },
  data() {
    return {
      activeTab: 0,
    }
  },
}
</script>

<style scoped>
.home-services-container2 {
  width: 100%;
  display: grid;
  grid-gap: var(--dl-layout-space-fiveunits);
  position: relative;
  grid-template-columns: 1fr 1fr;
}
 
.home-services-tabs-menu {
  gap: var(--dl-layout-space-twounits);
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
}
 
.home-services-tab-horizontal1 {
  gap: var(--dl-layout-space-twounits);
  cursor: pointer;
  display: flex;
  overflow: hidden;
  align-self: stretch;
  align-items: flex-start;
  flex-shrink: 0;
}
 
.home-services-divider-container1 {
  display: flex;
  align-self: stretch;
  align-items: flex-start;
}
 
.home-services-container3 {
  width: 2px;
  align-self: stretch;
  background-color: var(--dl-color-theme-neutral-dark);
}
 
.home-services-content1 {
  gap: 16px;
  flex: 1;
  display: flex;
  overflow: hidden;
  flex-grow: 1;
  align-items: flex-start;
  flex-shrink: 0;
  flex-direction: column;
  justify-content: center;
}
 
.home-services-tab-horizontal2 {
  gap: var(--dl-layout-space-twounits);
  cursor: pointer;
  display: flex;
  overflow: hidden;
  align-self: stretch;
  align-items: flex-start;
  flex-shrink: 0;
}
 
.home-services-divider-container2 {
  display: flex;
  align-self: stretch;
  align-items: flex-start;
}
 
.home-services-container4 {
  width: 2px;
  align-self: stretch;
  background-color: var(--dl-color-theme-neutral-dark);
}
 
.home-services-content2 {
  gap: 16px;
  flex: 1;
  display: flex;
  overflow: hidden;
  flex-grow: 1;
  align-items: flex-start;
  flex-shrink: 0;
  flex-direction: column;
  justify-content: center;
}
 
.home-services-image-container {
  height: 100%;
  display: flex;
  position: relative;
}
 
.home-services-image1 {
  animation-name: fadeIn;
  animation-delay: 0s;
  animation-duration: 300ms;
  animation-direction: normal;
  animation-iteration-count: 1;
  animation-timing-function: ease;
}
 
.home-services-image2 {
  animation-name: fadeIn;
  animation-delay: 0s;
  animation-duration: 300ms;
  animation-direction: normal;
  animation-iteration-count: 1;
  animation-timing-function: ease;
}
 
.home-services-fragment1 {
  display: contents;
}
 
.home-services-text1 {
  display: inline-block;
}
 
.home-services-fragment2 {
  display: contents;
}
 
.home-services-text2 {
  display: inline-block;
}
 
.home-services-fragment3 {
  display: contents;
}
 
.home-services-text3 {
  display: inline-block;
}
 
.home-services-fragment4 {
  display: contents;
}
 
.home-services-text4 {
  display: inline-block;
}
 

 
@media(max-width: 991px) {
  .home-services-container2 {
    grid-gap: var(--dl-layout-space-twounits);
    grid-template-columns: 1fr;
  }
  .home-services-tabs-menu {
    order: 2;
  }
}
</style>
